(function() {

    function c24OpenLoginLayerGeneric(e, self) {

        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        const redirectUrl = self ? $(self).data('redirect') : undefined;
        const loginType = self ? $(self).data('loginType') : 'default';

        if (window.c24LpIsApp) {
            const href = redirectUrl ? redirectUrl : window.location.href;
            const hrefParts = new URL(href);
            const hrefLogin = href.replace(hrefParts.protocol, 'c24-app-login:');
            window.location.href = hrefLogin;
            return;
        }

        if (window.c24LpInitLoginLayer) {
            window.c24LpInitLoginLayer();
            window.c24LpInitLoginLayer = undefined;
        }

        window.c24LpAfterLoginLayerLogin = function(oStatus = {}) {

            if (!oStatus || !oStatus.STATE || oStatus.STATE === 'browserback' || oStatus.STATE === '') {
                return false;
            }

            const loginEvent = new CustomEvent('c24LpLoginEvent', {
                detail: {
                    type: loginType,
                },
            });
            document.dispatchEvent(loginEvent);

            if (redirectUrl) {
                window.location.href = redirectUrl;
            } else {
                location.reload();
            }
        };

        window.addEventListener('uli-login-layer', function _listener(e) {

            window.removeEventListener('uli-login-layer', _listener);

            if ('detail' in e) {
                window.c24LpAfterLoginLayerLogin(e.detail.ul);
            } else {
                window.c24LpAfterLoginLayerLogin();
            }
        });

        window.c24LpFrameJsReady.then(function() {
            window.Check24.uliloginlayer.open();
        });
    }

    window.c24OpenLoginLayer = (e, self) => window.c24LpFrameJsReady.then(() => c24OpenLoginLayerGeneric(e, self));
    window.c24OpenLoginLayerGeneric = window.c24OpenLoginLayer;

    $.fn.extend({
        c24BindLoginLayer: function() {
            this.addClass('js24OpenLoginLayer');
        },
        c24BindRegisterLayer: function() {
            this.addClass('js24OpenRegisterLayer');
        },
    });

    $(document).ready(function() {

        $(document).on('click', '.js24OpenLoginLayer, .js24OpenRegisterLayer, .js24AutoOpenLoginLayer, .js24AutoOpenRegisterLayer', function(e) {
            window.c24LpFrameJsReady.then(() => c24OpenLoginLayerGeneric(e, this));

            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        // js24AutoOpenLoginLayer is not used at the moment - uncomment if needed
        //$('.js24AutoOpenLoginLayer').first().click();

        // js24AutoOpenRegisterLayer is not used at the moment - uncomment if needed
        //$('.js24AutoOpenRegisterLayer').first().click();
    });
})();
